module.exports = __webpack_public_path__ + "img/1150623452.13eb7192.jpg";